import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import SharingLinkKind from 'owa-service/lib/contract/SharingLinkKind';

export function getAttachmentPermissionLevelFromSharingLinkKind(
    linkKind: SharingLinkKind
): AttachmentPermissionLevel {
    switch (linkKind) {
        case SharingLinkKind.AnonymousEdit:
            return AttachmentPermissionLevel.AnonymousEdit;
        case SharingLinkKind.AnonymousView:
            return AttachmentPermissionLevel.AnonymousView;
        case SharingLinkKind.OrganizationEdit:
            return AttachmentPermissionLevel.OrganizationEdit;
        case SharingLinkKind.OrganizationView:
            return AttachmentPermissionLevel.OrganizationView;
        default:
            return AttachmentPermissionLevel.None;
    }
}
